import axiosAPI from '../axiosAPI';

/**
 * Service para gerenciar assinaturas com a API do Asaas
 */
export const subscriptionService = {
  /**
   * Criar nova assinatura
   * @param {number} planId - ID do plano (1-5)
   * @param {string} billingType - Tipo de pagamento: 'CREDIT_CARD', 'BOLETO', 'PIX'
   */
  async subscribe(planId, billingType) {
    const response = await axiosAPI.post('/subscriptions/subscribe', {
      plan_id: planId,
      billing_type: billingType
    });
    return response.data;
  },

  /**
   * Buscar assinatura atual do usuário
   */
  async getCurrent() {
    const response = await axiosAPI.get('/subscriptions/current');
    return response.data;
  },

  /**
   * Fazer upgrade de plano
   * @param {number} planId - ID do novo plano
   */
  async upgrade(planId) {
    const response = await axiosAPI.post('/subscriptions/upgrade', {
      plan_id: planId
    });
    return response.data;
  },

  /**
   * Cancelar assinatura atual
   */
  async cancel() {
    const response = await axiosAPI.post('/subscriptions/cancel');
    return response.data;
  },

  /**
   * Buscar histórico de assinaturas
   */
  async getHistory() {
    const response = await axiosAPI.get('/subscriptions/history');
    return response.data;
  },

  /**
   * Buscar histórico de pagamentos da assinatura ativa
   */
  async getPayments() {
    const response = await axiosAPI.get('/subscriptions/payments');
    return response.data;
  }
};
